import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import Typography from '@material-ui/core/Typography';
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import Divider from '@mui/material/Divider';


export default function DeleteDialog(props) {
    const classes = useStyles();
    return <Dialog onClose={props.handleClose} aria-labelledby="customized-dialog-title" open={props.open} maxWidth="md">
                <DialogContent dividers>
                    <div className={classes.dialog}>
                        <DeleteOutlineOutlinedIcon className={classes.deleteIcon}></DeleteOutlineOutlinedIcon>
                        <Typography className={classes.deleteText}>{props.toBeDeleted !== 0 ? (props.toBeDeleted.sentToMatis !== '0001-01-01T00:00:00' ? "LET OP! Deze registratie werd reeds verzonden naar MATIS!" : "Zeker dat u deze registratie wilt verwijderen?") : "Zeker dat u deze registratie wilt verwijderen?"}</Typography>
                        <Divider />

                        <div>
                            {props.toBeDeleted !== 0 ? (props.toBeDeleted.sentToMatis !== '0001-01-01T00:00:00' ? "Deze registratie werd reeds verzonden op: " + props.toBeDeleted.sentToMatis : "") : ""}
                        </div>
                        <div className={classes.buttonsDiv}>
                             <Button autoFocus variant="outlined" onClick={props.handleClose} color="primary">
                            {"Annuleren"}
                        </Button>
                        <Button className={classes.deleteButton} variant="contained" onClick={() => props.handleDelete(props.id)} color="primary">
                            {"Verwijderen"}
                        </Button>
                        </div>
                       
                    </div>
                </DialogContent>
            </Dialog>
}

const useStyles = makeStyles({
    spacer80: {
        height: '80px'  
      },
  
      paper: {
          padding: '50px',
          margin: "50px",
          height: '70%'
      },

      dialog: {
          paddingLeft: "50px",
          paddingRight: "50px",
          paddingTop: "15px",
          paddingBottom: "15px",
          justifyContent: "center",
          textAlign: "center"
      },

      deleteIcon: {
          fontSize: "100pt",
          color: "gray",
          width: "100px !important",
          height: "100px !important",
      },

      deleteText: {
          fontSize: "20pt"
      },

      deleteTexsmall: {
          fontSize: "14pt"
      },

      deleteButton: {
          backgroundColor: "#D84949 !important",
          margin: "10px"
      },
      buttonsDiv: {
          marginTop: '50px'
      }
});